import {
  FacebookFilled,
  InstagramFilled,
  LinkedinFilled,
  MailOutlined,
  PhoneOutlined,
  YoutubeFilled,
} from "@ant-design/icons";
import { Col, Form, Image, Layout, Row, Typography } from "antd";

import React, { useEffect, useState } from "react";
import Button from "../../components/Button/index";
import Footer from "../../components/layouts/HomeLayout/Footer";
import ContactBanner from "../../assets/img/contact-banner.webp";
import { useMediaPredicate } from "react-media-hook";
import { Link } from "react-router-dom";
import Burger from "../../components/layouts/HomeLayout/Burger";
import { useScroll } from "../../utils/useScroll";
import Logo from "../../assets/img/logo-mobility.webp";

function ContactMobility() {
  const [form] = Form.useForm();
  const biggerThan900 = useMediaPredicate("(min-width: 992px)");

  const [visible, setVisible] = useState(false);
  const [isHome, setIsHome] = useState();

  useEffect(() => {
    form.setFieldsValue({
      "vehicle-number": "1",
      phonePrefix: "56",
    });
  }, []);

  const burguerData = [
    {
      title: "Sucursales",
      link: "/sucursales",
    },
    {
      title: "Nuestros servicios",
      link: "#servicios",
    },
    {
      title: "Quienes Somos",
      link: "#nosotros",
    },
    { title: "Beneficios", link: "#beneficios" },
    { title: "Publicaciones", link: "#publicaciones" },
  ];

  useEffect(() => {
    form.setFieldsValue({
      phonePrefix: "56",
    });
  }, []);

  const { scrollDirection } = useScroll();

  useEffect(() => {
    if (window.location.pathname === "/contacto-mobility") {
      setIsHome(false);
    } else {
      setIsHome(true);
    }
  }, [window.location.pathname]);

  const styles = {
    active: {
      // visibility: "visible",
      transition: "all 0.2s ease-in-out",
    },
    hidden: {
      // visibility: "hidden",
      transition: "all 0.2s ease-in-out",
      transform: biggerThan900 && "translateY(-2.3rem)",
    },
  };

  const { Text } = Typography;
  return (
    <div>
      <Layout>
        <section
          className="home-banner-container"
          id="header"
          style={{
            height: `60vh`,
          }}
        >
          <Row
            className="header-contain"
            style={{
              backgroundImage: `url(${ContactBanner})`,
            }}
          >
            <Col
              id="navbar"
              style={
                scrollDirection === "down" || !scrollDirection
                  ? styles.active
                  : styles.hidden
              }
            >
              <nav className="home-nav-container">
                <ul>
                  <li>
                    <a
                      target="_blank"
                      href={"https://gamamobility.cl/"}
                      rel="noreferrer"
                    >
                      GAMA MOBILITY
                    </a>
                  </li>
                  <li>
                    <Link
                      style={{
                        color:
                          window.location.pathname === "/"
                            ? "#FF3200"
                            : "white",
                      }}
                      to={"/"}
                    >
                      GAMA LEASING
                    </Link>
                  </li>

                  <li>
                    <a href={"https://www.gamarent.cl/"}>RENT A CAR</a>
                  </li>
                  <li>
                    <a href={"https://www.tripp.cl/"}>TRIPP</a>
                  </li>
                  <li>
                    <Link to={"/usados"}>GAMA USADOS</Link>
                  </li>
                </ul>
              </nav>
              <header>
                <div className="home-nav-items">
                  <div className="home-nav-logo">
                    <Link to={"/mobility"}>
                      <Image
                        preview={false}
                        src={Logo}
                        style={{ width: "130px" }}
                      />
                    </Link>
                  </div>
                  <div className="group-nav-items">
                    <div
                      className="nav-container-buttons"
                      style={{
                        transition: "all ease-out 1s;",
                        opacity: `${visible ? "0" : "1"}`,
                        pointerEvents: `${visible ? "none" : "auto"}`,
                      }}
                    >
                      <Link to="/contacto-mobility">
                        <Button
                          onClick={() => {}}
                          className="gama-outline talk-button"
                        >
                          Conversemos
                        </Button>
                      </Link>
                    </div>
                    <div className="container-menu">
                      {biggerThan900 ? (
                        <div className="container-navlinks">
                          {isHome ? (
                            <>
                              <a smooth href="/sucursales">
                                Sucursales
                              </a>
                              <a smooth href="#servicios">
                                Nuestros Servicios
                              </a>
                              <a smooth href="#nosotros">
                                Quienes Somos
                              </a>
                              <a smooth href="#beneficios">
                                Beneficios
                              </a>
                              <a smooth href="#publicaciones">
                                Publicaciones2
                              </a>
                            </>
                          ) : (
                            <>
                              <Link to="/sucursales">Sucursales</Link>
                              <Link to="/mobility#servicios">
                                Nuestros Servicios
                              </Link>
                              <Link to="/mobility#nosotros">Quienes Somos</Link>
                              <Link to="/mobility#beneficios">Beneficios</Link>
                              <Link to="/mobility#publicaciones">Publicaciones</Link>
                            </>
                          )}
                        </div>
                      ) : (
                        <Burger
                          data={burguerData}
                          modal={visible}
                          onClose={() => {
                            setVisible(!visible);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </header>
            </Col>
          </Row>
          <div className="banner-title-container">
            <h1
              style={{
                textAlign: "left",
                paddingLeft: biggerThan900 ? "8.125rem" : "20px",
              }}
            >
              Conversemos
            </h1>
            <h3
              style={{
                textAlign: "left",
                lineHeight: "35px",
                fontSize: "40px",
                fontWeight: "400",
                maxWidth: biggerThan900 ? "" : "300px",
                // marginRight: biggerThan900 ? "1120px" : "",
                paddingLeft: biggerThan900 ? "8.125rem" : "0",
              }}
            >
              Programa una consulta gratuita con nuestro equipo.
            </h3>
          </div>
        </section>
      </Layout>
      <Row>
        <Col span={7}>
          {biggerThan900 ? (
            <Row
              style={{
                backgroundColor: "#2D2D2D",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "left",
              }}
            >
              <Row
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                <Text
                  style={{
                    color: "white",
                    marginBottom: "10px",
                    marginTop: " 40px",
                  }}
                >
                  Contacto
                </Text>
                <Row
                  justify="start"
                  style={{ color: "white", marginBottom: "5px" }}
                >
                  <Col>
                    <PhoneOutlined
                      style={{ color: "#FF3200", marginRight: "15px" }}
                    />
                  </Col>
                  <Col style={{ color: "white" }}>+56 93 918 5879</Col>
                </Row>
                <Row>
                  <Col>
                    <MailOutlined
                      style={{ color: "#FF3200", marginRight: "15px" }}
                    />
                  </Col>
                  <Col style={{ color: "white" }}>contacto@gamaleasing.cl </Col>
                </Row>
                <Text
                  style={{
                    color: "white",
                    marginTop: "30px",
                    marginBottom: "15px",
                  }}
                >
                  Siguenos
                </Text>
                <Row justify="space-evenly" style={{ width: "200px" }}>
                  <Col>
                    <FacebookFilled
                      style={{
                        color: "white",
                        backgroundColor: "rgb(255, 255, 255, 0.1)",
                        padding: "10px 10px",
                        borderRadius: "20px",
                        fontSize: "20px",
                      }}
                    />
                  </Col>
                  <Col>
                    <InstagramFilled
                      style={{
                        color: "white",
                        backgroundColor: "rgb(255, 255, 255, 0.1)",
                        padding: "10px 10px",
                        borderRadius: "20px",
                        fontSize: "20px",
                      }}
                    />
                  </Col>
                  <Col>
                    <LinkedinFilled
                      style={{
                        color: "white",
                        backgroundColor: "rgb(255, 255, 255, 0.1)",
                        padding: "10px 10px",
                        borderRadius: "20px",
                        fontSize: "20px",
                      }}
                    />
                  </Col>
                  <Col>
                    <YoutubeFilled
                      style={{
                        color: "white",
                        backgroundColor: "rgb(255, 255, 255, 0.1)",
                        padding: "10px 10px",
                        borderRadius: "20px",
                        fontSize: "20px",
                      }}
                    />
                  </Col>
                </Row>
              </Row>
            </Row>
          ) : null}
        </Col>
        <Col xs={24} sm={24} md={12}>
          <Row
            style={{
              flexDirection: "column",
              border: "1px solid rgba(255, 50, 0, 0.1)",
              margin: "50px 30px 50px 60px",
              padding: "50px 50px 0px 50px",
              borderRadius: "17px",
            }}
          >
            <Col>
              <Text strong style={{ fontSize: "20px" }}>
                ¿Que necesitas?
              </Text>
            </Col>
            <Col style={{ paddingBottom: "30px" }}>
              <Text>
                Llena el siguiente formulario y te responderemos a la brevedad.
              </Text>
            </Col>
            <Col>
              <Row style={{ marginBottom: "25px" }}>
                <Button
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    marginRight: "15px",
                  }}
                >
                  <a href="https://www.gamarent.cl/contacto">Rent A Car</a>
                </Button>
                <Button
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    marginRight: "15px",
                  }}
                >
                  <a href="https://www.tripp.cl/contactenos">Tripp</a>
                </Button>
                <Button
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    marginRight: "15px",
                  }}
                >
                  <a href="https://gamaleasing.cl/contacto-usado">Gama usados</a>
                </Button>
                <Button
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    marginRight: "15px",
                  }}
                >
                  <a href="https://gamaleasing.cl/contacto">Gama Leasing</a>
                </Button>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      <Footer logo={Logo} />
    </div>
  );
}

export default ContactMobility;
